<cb-dialog>
    <form class="flex-col flex" #manageLocations="ngForm">
        <div class="flex-col flex">
            @for (region of regions; track region) {
                <cb-checkbox
                    [label]="region.name"
                    [name]="'region' + region.id"
                    [ngModel]="isRegionChecked(region.id)"
                    (change)="onRegionChanged(region.id, $event)"
                ></cb-checkbox>
            }
        </div>
    </form>
    <div actions>
        <span class="flex"></span>
        <button
            mat-raised-button
            class="save-button"
            color="primary"
            [disabled]="!manageLocations.valid || !manageLocations.dirty"
            (click)="saveClicked()"
        >
            Save
        </button>
        <button mat-raised-button (click)="dialogRef.close()">Cancel</button>
    </div>
</cb-dialog>
